<template>
  <div class="side-panel">
    <v-layout
      column
      align-center
      align-content-center
      justify-center
      white
      pt-5
    >
      <v-flex xs10 md5>
        <v-select
          :items="langs"
          v-model="locale"
          item-text="name"
          item-value="locale"
          :label="$t('language')"
        >
        </v-select>
      </v-flex>
      <v-btn v-if="decodedToken && decodedToken.companyID == 14"
        class="secondary"
        @click="resetDemo()"
        medium>
        Reset Demo
      </v-btn>
      <p style='margin-top: 5rem'>{{ $t('account.graphTemperatures') }}:</p>
      <v-radio-group v-model="inCelsius" @change="changeTemperatureMode">
        <v-radio :label="$t('account.celsius')" v-bind:value="true"></v-radio>
        <v-radio :label="$t('account.fahrenheit')" v-bind:value="false"></v-radio>
      </v-radio-group>

      <p style='margin-top: 5rem'>{{$t('account.changePassword')}}</p>
      <v-text-field
        name="password"
        :label="$t('account.oldPassword')"
        :type="showPasswordFirst ? 'text' : 'password'"
        v-model="oldPassword"
        autocomplete="password"
        required
      >
        <template v-slot:append>        
          <v-icon size="18" @click="() => (showPasswordFirst = !showPasswordFirst)"> {{showPasswordFirst ? 'fa-eye' : 'fa-eye-slash'}} </v-icon> 
        </template>
      </v-text-field>
      <v-text-field
        name="password-new"
        :label="$t('account.newPassword')"
        :type="showPasswordSecond ? 'text' : 'password'"
        v-model="newPassword"
        autocomplete="new-password"
        required
      >
        <template v-slot:append>        
          <v-icon size="18" @click="() => (showPasswordSecond = !showPasswordSecond)"> {{showPasswordSecond ? 'fa-eye' : 'fa-eye-slash'}} </v-icon> 
        </template>
      </v-text-field>
      <v-text-field
        name="password-new-confirm"
        :label="$t('account.confirmPassword')"
        :type="showPasswordThird ? 'text' : 'password'"
        v-model="newPasswordConfirm"
        autocomplete="new-password"
        required
      >
        <template v-slot:append>        
          <v-icon size="18" @click="() => (showPasswordThird = !showPasswordThird)"> {{showPasswordThird ? 'fa-eye' : 'fa-eye-slash'}} </v-icon> 
        </template>
      </v-text-field>
      <v-btn
        :disabled="!oldPassword || !newPassword || newPassword !== newPasswordConfirm"
        class="secondary login-button"
        @click="changePassword">
        {{$t('account.changePassword')}}
      </v-btn>
      <v-alert
        v-model="alert"
        border="left"
        close-text="Close Alert"
        :type="alertType"
        dark
        dismissible
      >
      {{alertText}}
      </v-alert>
    </v-layout>
    <div class="danger-alert" v-if="error">{{ error }}</div>
  </div>
</template>

<script>
import AuthenticationService from '@/services/AuthenticationService';
import DemoFarmService from "@/services/DemoFarmService";
import UserService from "@/services/UsersService";

import { mapActions, mapState } from 'vuex';

export default {
  data() {
    return {
      locale: this.$store.state.locale,
      langs: [
        { name: 'English', locale: 'en' },
        { name: 'Italiano', locale: 'it' },
        { name: 'Magyar', locale: 'hu' },
        { name: 'Nederlands', locale: 'nl' },
        { name: 'Polskie', locale: 'pl' },
        { name: 'Русский', locale: 'ru' },
        { name: 'Slovenský', locale: 'sk' },
        { name: 'Norsk', locale: 'no' },
        { name: 'Lietuvių', locale: 'lt' },
        { name: 'Deutsch', locale: 'de' },
        { name: 'Français', locale: 'fr' },
      ],
      error: null,
      oldPassword: '',
      newPassword: '',
      newPasswordConfirm: '',
      showPasswordFirst: false,
      showPasswordSecond: false,
      showPasswordThird: false,
      alert: false,
      alertText: '',
      alertType: 'info',
      decodedToken: null,
      inCelsius: true,
    };
  },
  computed:{
    ...mapState(['user','token']),
  },
  methods: {
    parseJwt (token) {
      const decoded = JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString());
      return decoded;
    },
    async setCelsiusSetting(){
      if(this.user.celsius == undefined && this.$store.state.token){
        await this.fetchAndSetUserCelsius();
      }
      this.inCelsius = this.user.celsius;
    },
    async changeTemperatureMode(inCelsius){
      try{
        this.error = ''
        const newUser = {"id":this.decodedToken.userID, "celsius":inCelsius}
        await UserService.put(newUser)
        this.$store.dispatch('setUser', {...this.user, celsius: inCelsius})
        
      } catch (error) {
        this.error = error.response.data.error.message
      }
    },
    async changePassword () {
      try {
        this.error = ''
        const response = await AuthenticationService.changePassword({
          old_password: this.oldPassword,
          new_password: this.newPassword
        })
        const requestFailed = response.status != 200;
        this.response = response.data;
        this.alertText = requestFailed ? this.$t('account.pwChangeFail') : this.$t('account.pwChangeSuccess');
        this.alertType = requestFailed ? 'error' : 'success';
        this.alert = true;
        this.oldPassword = '';
        this.newPassword = '';
        this.newPasswordConfirm = '';
      } catch (error) {
        this.error = error.response.data.error.message
      }
    },
    async resetDemo(){
      const response = await DemoFarmService.resetDemo()
      
      if (response.status != 200) {
        alert("Couldn't reset Demo Farm");
      } else {
        alert(response.data);
      }
    },
    ...mapActions(['fetchAndSetUserCelsius','setUser'])
  },
  watch: {
    locale: function(newValue, oldValue) {
      this.$i18n.locale = newValue;
      this.$moment.locale(newValue);
      this.$store.dispatch('setLocale', newValue);
      // refresh current page for set the
      // new language for the app everywhere
      location.reload();
    }
  },
  mounted(){
    this.decodedToken = this.parseJwt(this.$store.state.token);
    this.setCelsiusSetting();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/Settings.vue